import { AEMComponentProps } from 'types';


export interface Link {
  label: string;
  url: string;
}

export enum tPadding {
    small = "module--padded-top-s",
    medium = "module--padded-top-m",
    large = "module--padded-top-l",
    noSpace = "module--flat-top",
}

export enum bPadding {
  small = "module--padded-bottom-s",
  medium = "module--padded-bottom-m",
  large = "module--padded-bottom-l",
  noSpace = "module--flat-bottom",
}

export enum hPadding {
    fullWidth = "l-full-width",
    layout = "l-padding",
}

export interface AEMInPageNavigationProps extends AEMComponentProps {
  links?: Array<Link> | string;
  horizontalPadding? :hPadding | string;
  topVerticalPadding? : tPadding | string;
  bottomVerticalPadding? : bPadding | string;
}

export interface InPageNavigationProps extends AEMInPageNavigationProps {
  // no local props
}

export interface State {}

// Function to map specific props to be set in the state. This is to avoid clogging
// up the component render method with initial state logic
export const mapState = (props: InPageNavigationProps): State => {
  const {
    links,
  } = props;

  return {
    links,
  };
};
